<template>
  <div class="messageInfoRow">
    <div style="flex-grow:0" />
    <img class="forwardIcon" src="/images/forwardRow.png">
    <span class="forwardText">İletildi</span>
  </div>
</template>

<script>
import {
  messageMixin
} from '@/mixins/messageMixin.js'

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mixins: [messageMixin],
  created () {}
}
</script>

<style lang="less" scoped>
  .messageInfoRow {
    font-size: 14px;
    color: rgb(140, 140, 140);
    padding-top: 3px;
    padding-bottom: 3px;
    display: flex;
    margin-right: -15px;
  }

  .statusIcon {
    width: 10px;
    height: 10px;
    margin-left: 5px;
  }

  .forwardIcon {
    padding-left: 5px;
    width: 18px;
    height: 18px;
  }

  .forwardText {
    padding-left: 5px;
    padding-right: 18px;
    padding-top: 0px;
  }
</style>
